<template>
    <div>
        <div class="ul-top box-sizing">
            <div class="ul-item">
                <span class="lab">时间：</span>
                <span class="opt">
                    <el-date-picker
                            v-model="timeGroup"
                            type="daterange"
                            unlink-panels
                            value-format="timestamp"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :editable="false"
                            :picker-options="pickerOptions"
                            :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </span>
                <span class="lab">关键词：</span>
                <span class="opt"><el-input class="inp" placeholder="请输入分类名称" v-model="keyword" clearable></el-input></span>
                <span class="btn"><el-button type="primary" @click="getLabelList">搜索</el-button></span>
            </div>
            <div class="btn-features">
                <el-button type="success" @click="showAddLabelDialog">新建分类</el-button>
                <el-popconfirm title="确定删除选中的分类吗？" @confirm="delLabel" style="margin-left: 10px">
                    <el-button type="danger" slot="reference">删除选中</el-button>
                </el-popconfirm>
            </div>
        </div>
        <div class="ul-mid box-sizing">
            <el-table v-loading="isLoading" :data="tableData"  empty-text="暂无数据" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="42"></el-table-column>
                <el-table-column prop="create_time" label="添加日期"></el-table-column>
                <el-table-column prop="label" label="分类"></el-table-column>
                <el-table-column prop="label_mark" label="分类描述"></el-table-column>
                <el-table-column prop="num" label="链接数量" class-name="text-align"></el-table-column>
                <el-table-column prop="pv" label="PV" class-name="text-align"></el-table-column>
                <el-table-column prop="uv" label="UV" class-name="text-align"></el-table-column>
                <el-table-column prop="ip" label="IP" class-name="text-align"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="editLabel(scope.row)">修改</el-button>
                        <el-button type="text" size="small" @click="delLabel(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagebar" v-show="total>5">
                <el-pagination background layout="total, prev, pager, next, jumper" :total="total" @current-change="handleCurrentPage"></el-pagination>
            </div>
        </div>
        <el-dialog title="设置备注" :visible.sync="addLabelDialog" center width="400px">
            <span>
                <el-form :model="labelData" :rules="labelRules" ref="labelForm">
                    <el-form-item label="分类名称" prop="name">
                        <el-input v-model="labelData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="分类描述" prop="mark">
                        <el-input v-model="labelData.mark"></el-input>
                    </el-form-item>
                </el-form>
            </span>
            <span slot="footer">
                <el-button @click="addLabelDialog=false">取消</el-button>
                <el-button type="primary" :loading="addLabelLoad" @click="addLabel">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "UserLabel",
        data() {
            return {
                total: 0,
                keyword: "",
                selUrlID: "",
                timeGroup: [],
                tableData: [],
                isLoading: false,
                currentPage: 1,
                addLabelLoad: false,
                addLabelDialog: false,
                labelData: {
                    id: 0,
                    name: "",
                    mark: "",
                },
                labelRules:{
                    name: [
                        { required: true, message: '请输入分类名称', trigger: 'blur' },
                        { min: 1, max: 8, message: '长度在 1 到 8 个字符', trigger: 'blur' }
                    ],
                    mark: [
                        { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                    ],
                },
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        mounted() {
            setTimeout(this.getLabelList,200);
        },
        methods: {
            async getLabelList() {
                this.isLoading = true;
                let start = 0;
                let end = 0;
                if (this.timeGroup === null) this.timeGroup = [];
                if (this.timeGroup.length === 2){
                    start = this.timeGroup[0];
                    end = this.timeGroup[1];
                }
                const getData = {
                    start: Number(start/1000),
                    end: Number(end/1000),
                    keyword: this.keyword,
                    p: this.currentPage,
                };
                const {ret,data} = await this.$api.urlLabel.getLabelList(getData);
                this.isLoading = false;
                if (ret === 1000){
                    this.total = Number(data['total']);
                    this.tableData = data['list'];
                }
            },
            addLabel() {
                const $this = this;
                $this.addLabelLoad = true;
                $this.$refs.labelForm.validate(async (valid) => {
                    if (valid) {
                        let postData = {
                            id: $this.labelData.id,
                            name: $this.labelData.name,
                            mark: $this.labelData.mark,
                        };
                        const {ret} = await $this.$api.urlLabel.updateLabel(postData);
                        $this.addLabelLoad = false;
                        if (ret === 1000){
                            $this.addLabelDialog = false;
                            $this.$message.success("添加成功！");
                            await $this.getLabelList();
                        }
                    }else {
                        $this.addLabelLoad = false;
                    }
                });
            },
            delLabel(id) {
                let ids = "";
                if (id){
                    ids = id;
                }else {
                    ids = this.selUrlID;
                }
                if (ids === ""){
                    this.$message.error("请选择要删除的分类！");
                    return;
                }
                this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const {ret} = await this.$api.urlLabel.delLabel({ids:ids});
                    if (ret === 1000){
                        this.getLabelList();
                        this.$message.success("删除成功！");
                    }
                });
            },
            editLabel(item){
                this.labelData.id = item.id;
                this.labelData.name = item.label;
                this.labelData.mark = item.label_mark;
                this.addLabelDialog = true;
            },
            showAddLabelDialog() {
                this.labelData.id = 0;
                this.labelData.name = "";
                this.labelData.mark = "";
                this.addLabelDialog = true;
            },
            handleCurrentPage(val) {
                this.currentPage = val;
                this.getLabelList();
            },
            handleSelectionChange(val) {
                if (val.length === 0){
                    return;
                }
                let ids = "";
                for (const item of val){
                    ids += item.id+",";
                }
                ids = ids.substr(0,ids.length-1);
                this.selUrlID = ids;
            }
        }
    }
</script>

<style scoped>
    .ul-top{
        width: 100%;
        height: auto;
        padding: 20px;
    }
    .ul-top .ul-item{
        width: 100%;
        height: 40px;
        color: #666666;
        margin-bottom: 10px;
    }
    .ul-top .ul-item .lab{
        display: inline-block;
        width: 70px;
        height: 40px;
        font-size: 14px;
        line-height: 40px;
        text-align: right;
        margin-right: 10px;
        vertical-align: top;
    }
    .ul-top .ul-item .opt{
        display: inline-block;
        width: 350px;
        height: 40px;
        vertical-align: top;
    }
    .ul-top .ul-item .btn{
        display: inline-block;
        width: 70px;
        height: 40px;
        margin-left: 10px;
        vertical-align: top;
    }
    .ul-top .ul-item .inp{
        width: 350px;
    }
    .ul-top .btn-features{
        width: 100%;
        height: 40px;
        margin-top: 30px;
    }
    .ul-mid{
        width: 100%;
        padding: 0 20px;
    }
    .ul-mid .pagebar{
        width: 100%;
        height: 52px;
        margin-top: 20px;
    }
</style>
